import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { W as WppIcon } from './WppIcon.js';

const wppIconCss = ":host{display:-ms-inline-flexbox;display:inline-flex;color:var(--wpp-prop-icon-color)}";

const WppIconPeople$1 = /*@__PURE__*/ proxyCustomElement(class WppIconPeople extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.size = 'm';
    this.width = undefined;
    this.height = undefined;
    this.color = 'var(--wpp-icon-color)';
  }
  render() {
    return (h(WppIcon, { name: "wpp-icon-people", width: this.width, height: this.height, size: this.size, color: this.color }, h("path", { d: "M3.6 11.1996L10.8 11.2004C11.6431 11.2004 12.3345 11.8528 12.3956 12.6809L12.4 12.8004V14.0004C12.3992 16.8004 9.4272 17.6004 7.2 17.6004C5.02229 17.6004 2.13176 16.8356 2.00436 14.1841L2 14.0004V12.7996C2 11.9565 2.65312 11.2651 3.48065 11.204L3.6 11.1996ZM12.576 11.2004H16.4C17.2431 11.2004 17.9345 11.8535 17.9956 12.681L18 12.8004V13.6004C17.9992 16.05 15.7136 16.8004 14 16.8004C13.456 16.8004 12.8552 16.7236 12.288 16.5428C12.5568 16.234 12.7736 15.8812 12.9296 15.4812C13.364 15.5812 13.772 15.6004 14 15.6004L14.2132 15.5956C15.0014 15.5611 16.6823 15.3049 16.7941 13.7644L16.8 13.6004V12.8004C16.8 12.6041 16.6578 12.4407 16.4717 12.4068L16.4 12.4004H13.1592C13.092 11.9993 12.9244 11.6349 12.6836 11.3282L12.576 11.2004H16.4H12.576ZM3.6 12.3996L3.51948 12.4076C3.41997 12.4278 3.352 12.4818 3.3168 12.5164C3.28224 12.5516 3.22822 12.619 3.208 12.7188L3.2 12.7996V14.0004C3.2 14.8076 3.56 15.378 4.3336 15.794C4.99452 16.1499 5.93561 16.3654 6.94606 16.3965L7.2 16.4004L7.45392 16.3965C8.46428 16.3654 9.40474 16.1499 10.0664 15.794C10.7909 15.404 11.1533 14.8783 11.1958 14.1483L11.2 13.9996V12.8004C11.2 12.6041 11.0578 12.4407 10.8717 12.4068L10.8 12.4004L3.6 12.3996ZM7.2 2.40039C9.188 2.40039 10.8 4.01239 10.8 6.00039C10.8 7.98839 9.188 9.60039 7.2 9.60039C5.212 9.60039 3.6 7.98839 3.6 6.00039C3.6 4.01239 5.212 2.40039 7.2 2.40039ZM14.4 4.00039C15.9464 4.00039 17.2 5.25399 17.2 6.80039C17.2 8.34679 15.9464 9.60039 14.4 9.60039C12.8536 9.60039 11.6 8.34679 11.6 6.80039C11.6 5.25399 12.8536 4.00039 14.4 4.00039ZM7.2 3.60039C5.8768 3.60039 4.8 4.67719 4.8 6.00039C4.8 7.32359 5.8768 8.40039 7.2 8.40039C8.5232 8.40039 9.6 7.32359 9.6 6.00039C9.6 4.67719 8.5232 3.60039 7.2 3.60039ZM14.4 5.20039C13.5176 5.20039 12.8 5.91799 12.8 6.80039C12.8 7.68279 13.5176 8.40039 14.4 8.40039C15.2824 8.40039 16 7.68279 16 6.80039C16 5.91799 15.2824 5.20039 14.4 5.20039Z", fill: "currentColor" })));
  }
  static get registryIs() { return "wpp-icon-people-v2-21-0"; }
  static get style() { return wppIconCss; }
}, [1, "wpp-icon-people", "wpp-icon-people-v2-21-0", {
    "size": [1],
    "width": [2],
    "height": [2],
    "color": [1]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["wpp-icon-people-v2-21-0"];
  components.forEach(tagName => { switch (tagName) {
    case "wpp-icon-people-v2-21-0":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, WppIconPeople$1);
      }
      break;
  } });
}

const WppIconPeople = WppIconPeople$1;
const defineCustomElement = defineCustomElement$1;

export { WppIconPeople, defineCustomElement };
